import { accessRejected, accessGranted, connectionClosedByPeer } from '../../actions/webrtcConnection'
import { dummyAction } from '../../actions/signaling'
import { notifyMonitors } from '../../actions/toolbar'
import {
  notifyCapturingStatusChanged,
  notifySendInputStatusChanged,
  screenSharing,
} from '../../actions/onDemand'
import {
  audioChatStartRequest,
  audioChatStartRequestCancel,
  audioChatStartResponse,
  audioChatEnd,
  audioChatPeerMicrophoneMuted,
} from '../../actions/media'
import {
  clipboardRemoteReceive
} from '../../actions/clipboard'
import { logger } from './../utils/logger'

require('../../proto/javascript/netop_rc_commands_pb')

/**
 * Parse protobuf messages arriving on commands channel of a webrtc connection
 */
export class CommandsMessageParser {

  constructor () {
    this.parseMap = {
      [proto.netop.rc.commands.CommandsMessageType.AVAILABLE_MONITORS]: (binaryMsg) => {
        const msg = proto.netop.rc.commands.AvailableMonitors.deserializeBinary(binaryMsg)
        const objAnswer = msg.toObject()
        const action = notifyMonitors(objAnswer.monitorsList)

        return action
      },

      [proto.netop.rc.commands.CommandsMessageType.CONFIRM_ACCESS]: (binaryMsg) => {
        const msg = proto.netop.rc.commands.ConfirmAccess.deserializeBinary(binaryMsg)
        const objAnswer = msg.toObject()

        const action = objAnswer.response === proto.netop.rc.commands.ConfirmAccessResponseType.ACCEPT
          ? accessGranted()
          : accessRejected()
        return action
      },

      [proto.netop.rc.commands.CommandsMessageType.CONNECTION_CLOSED]: () => {
        return connectionClosedByPeer()
      },

      [proto.netop.rc.commands.CommandsMessageType.SCREEN_CAPTURE_STATUS_CHANGED]: (binaryMsg) => {
        const msg = proto.netop.rc.commands.ScreenCaptureStatusChanged.deserializeBinary(binaryMsg)
        const objAnswer = msg.toObject()

        return notifyCapturingStatusChanged(objAnswer.status === proto.netop.rc.commands.ScreenCaptureStatus.SUSPENDED)
      },

      [proto.netop.rc.commands.CommandsMessageType.SEND_INPUT_STATUS_CHANGED]: (binaryMsg) => {
        const msg = proto.netop.rc.commands.SendInputStatusChanged.deserializeBinary(binaryMsg)
        const objAnswer = msg.toObject()

        return notifySendInputStatusChanged(objAnswer.status === proto.netop.rc.commands.SendInputStatus.DISALLOWED)
      },

      [proto.netop.rc.commands.CommandsMessageType.AUDIO_CHAT_START_REQUEST]: () => {
        return audioChatStartRequest({ requestByPeer: true })
      },

      [proto.netop.rc.commands.CommandsMessageType.AUDIO_CHAT_START_REQUEST_CANCEL]: () => {
        return audioChatStartRequestCancel({ cancelByPeer: true })
      },

      [proto.netop.rc.commands.CommandsMessageType.AUDIO_CHAT_START_RESPONSE]: (binaryMsg) => {
        const msg = proto.netop.rc.commands.AudioChatStartResponse.deserializeBinary(binaryMsg)
        const objAnswer = msg.toObject()

        return audioChatStartResponse({
          fromPeer: true,
          response: objAnswer.response === proto.netop.rc.commands.ResponseType.RT_YES,
        })
      },

      [proto.netop.rc.commands.CommandsMessageType.AUDIO_CHAT_END]: () => {
        return audioChatEnd({ endByPeer: true })
      },

      [proto.netop.rc.commands.CommandsMessageType.AUDIO_CHAT_MICROPHONE_MUTED]: () => {
        return audioChatPeerMicrophoneMuted(true)
      },

      [proto.netop.rc.commands.CommandsMessageType.AUDIO_CHAT_MICROPHONE_UNMUTED]: () => {
        return audioChatPeerMicrophoneMuted(false)
      },

      [proto.netop.rc.commands.CommandsMessageType.CLIPBOARD_TEXT]: (binaryMsg) => {
        const message = proto.netop.rc.commands.ClipboardText.deserializeBinary(binaryMsg)
        return clipboardRemoteReceive(message.toObject())
      },

      [proto.netop.rc.commands.CommandsMessageType.SCREEN_SHARING]: (binaryMsg) => {
        const msg = proto.netop.rc.commands.ScreenSharing.deserializeBinary(binaryMsg)
        const objMessage = msg.toObject()

        return screenSharing(objMessage.active === proto.netop.rc.commands.ScreenSharingStatus.ACTIVE)
      },
    }
  }

  default = (type) => () => {
    // ignore silently the messages with unknown type
    logger(` - unknown command message type ${type}`)
    return dummyAction()
  }

  parse = (binaryMsg) => {
    const commandsMsg = proto.netop.rc.commands.CommandsMessage.deserializeBinary(binaryMsg)
    const type = commandsMsg.getCommandsMessageType()
    logger(` - command rec type: ${type}`)

    const parser = this.parseMap[type] || this.default(type)
    return parser(binaryMsg)
  }
}
